import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { KcDataService } from '../../kc-data.service'
import { TranslationService } from '@emilfreydigital/transifex-angular'
import { KcCompanyFinishViewData } from '../../interfaces/kc-data.interface'

@Component({
  selector: 'customer-portal-app-kc-request-business-sent',
  templateUrl: './kc-request-business-sent.component.html',
  styleUrls: ['./kc-request-business-sent.component.scss']
})
export class KcRequestBusinessSentComponent implements OnInit {
  constructor(
    private readonly kcDataService: KcDataService,
    private readonly transifexTranslationsService: TranslationService
  ) {}

  @ViewChild('activationFinishForm', { static: true })
  private readonly formRef: ElementRef

  public viewData: KcCompanyFinishViewData
  public submitting: boolean

  ngOnInit(): void {
    this.viewData = this.kcDataService.getViewData() as KcCompanyFinishViewData
  }

  submit() {
    this.submitting = true

    // submit form
    const formElement = this.formRef.nativeElement as HTMLFormElement
    formElement.submit()
  }

  getTranslation(): string {
    return this.transifexTranslationsService.translate(
      'Our customer service will contact you shortly about setting up your business account.',
      {
        _key: 'customerPortal.kc.company-finish.text',
        _tags: 'kc-forms, 3.1'
      }
    )
  }
}
